// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3cmYH","title":"Info_title__T6zcX","selects":"Info_selects__27gn2","requiredAsterisk":"Info_requiredAsterisk__EPMsC"};